import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { returnUpDownClassname } from "utils/helpers";

const ExcursionCard = (props) => {
  const { metrics } = props.optionsResults;

  return (
    <GenericCard
      title="EOD Peak / Trough"
      tooltipText="Best and worst end-of-day CLOSING return seen along the way (not intraday high/low -- you only check once a day, so intraday swings you'd never act on aren't shown). Peak shows the best close you could've sold at if you'd taken an early win; trough shows the worst close you'd have sat through on the way to (or instead of) target."
    >
      <div className="flex gap-8">
        <div>
          <h5>Avg EOD peak</h5>
          <h3 className={returnUpDownClassname(metrics.avgEodPeakReturn)}>
            {metrics.avgEodPeakReturn}%
          </h3>
        </div>
        <div>
          <h5>Median EOD peak</h5>
          <h3 className={returnUpDownClassname(metrics.medianEodPeakReturn)}>
            {metrics.medianEodPeakReturn}%
          </h3>
        </div>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <h5>Avg EOD trough</h5>
          <h3 className={returnUpDownClassname(metrics.avgEodTroughReturn)}>
            {metrics.avgEodTroughReturn}%
          </h3>
        </div>
        <div>
          <h5>Median EOD trough</h5>
          <h3
            className={returnUpDownClassname(metrics.medianEodTroughReturn)}
          >
            {metrics.medianEodTroughReturn}%
          </h3>
        </div>
      </div>
    </GenericCard>
  );
};

ExcursionCard.propTypes = { optionsResults: PropTypes.object };

export default ExcursionCard;
